import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { delay, each, pick } from 'lodash';
import Toggle from 'react-bootstrap-toggle';
import {
  Button, FormGroup, ControlLabel, HelpBlock,
} from 'react-bootstrap';
import { reduxForm, formValueSelector, SubmissionError } from 'redux-form';
import { fetchFeedbackRequestSettings, updateFeedbackRequestSettings } from '../../../SetupActions';
import { getUserCurrentOrganization } from '../../../../Auth/AuthReducer';
import ProgressBar from '../../../../../components/progress-bar';

const attrName = 'multiple_group_submission_on_sync';

class AllowMuitpleGroupOnSync extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loaded: false,
      settings: {},
    };
    this.onToggleEnable = this.onToggleEnable.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  fetchData() {
    this.setState({ loading: true, loaded: false });
    this.props.dispatch(fetchFeedbackRequestSettings(this.props.organization._id))
      .then(
        (settings) => {
          if (this.mounted) {
            this.props.initialize(settings);
            this.setState({ settings, loading: false, loaded: true });
          }
        },
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: false });
          }
        },
      );
  }

  handleSubmit(data) {
    const attrs = [attrName, 'add_contacts', 'email_editing', 'can_make_contact_primary']
    const params = pick(data, attrs);
    each(attrs, (attr) => {
      params[attr] = params[attr] === true || params[attr] === 'true';
    });
    const p = this.props.dispatch(updateFeedbackRequestSettings(this.props.organization._id, params));
    return p.then(
      () => {
        const el = (<div>Settings updated</div>);
        this.context.addNotification(el, { type: 'success', autoClose: true });
      },
      (errors) => {
        const e = errors.data || errors;
        throw new SubmissionError(e);
      },
    );
  }

  onToggleEnable() {
    const { handleSubmit } = this.props;
    this.props.change(attrName, !this.props.allowMuitpleGroupOnSync);
    delay(() => {
      this.props.dispatch(handleSubmit(this.handleSubmit));
    }, 100);
  }

  render() {
    const { loading, loaded } = this.state;
    const { submitting, allowMuitpleGroupOnSync, handleSubmit } = this.props;
    
    if (loading) {
      return (
        <div><ProgressBar /></div>
      );
    }

    if (!loaded) {
      return null;
    }

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <FormGroup>
          <ControlLabel>Allow Multiple Group Submissions:&nbsp;</ControlLabel>
          <Toggle
            onClick={this.onToggleEnable}
            on={<span>Enabled</span>}
            off={<span>Disabled</span>}
            onstyle="success"
            size="xs"
            offstyle="danger"
            active={allowMuitpleGroupOnSync}
            disabled={submitting}
          />
        </FormGroup>
      </form>
    );
  }
}

const FORM_NAME = 'allowMuitpleGroupOnSyncForm';
const selector = formValueSelector(FORM_NAME);

function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
    allowMuitpleGroupOnSync: selector(state, attrName),
  };
}

AllowMuitpleGroupOnSync.propTypes = {
  dispatch: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  allowMuitpleGroupOnSync: PropTypes.bool,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
};
AllowMuitpleGroupOnSync.defaultProps = {
  submitting: false,
  allowMuitpleGroupOnSync: false,
};
AllowMuitpleGroupOnSync.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

const AllowMuitpleGroupOnSyncForm = reduxForm({
  form: FORM_NAME,
}, { touchOnChange: true })(AllowMuitpleGroupOnSync);

export default connect(mapStateToProps)(AllowMuitpleGroupOnSyncForm);
